import { _tr, _td, TableTool } from "../../tool/TableTool";
import { TabKeys } from "../../tool/TabKeys";
import { memberTreeDataTablKey, memberDataTablKey } from "../tableKey/memberFlowStatsTK";

const memberDataEndTK = TabKeys.byTabKeysGetEndChilds(memberDataTablKey);

export function MemberFlowTable({ data }: { data }) {
    if (!data) { return <div></div> }

    const getTabTds1 = (data): _tr => {
        return memberDataEndTK.map((item, index) => {
            return <td key={index}>{data[item.key]}</td> as _td;
        });
    }
    const getTabTds = (data): _tr[] => {
        let _trs: _tr[] = data.memberExpend.map((item) => {
            return getTabTds1(item);
        });
        //第一列数据加上分类信息
        _trs[0] && _trs[0].unshift(<td className="dark" rowSpan={_trs.length}>{data.shopName}</td> as _td);
        return _trs;
    };

    return <>
        <thead>
            {TableTool.getTreeTabThs([ ...memberTreeDataTablKey,...memberDataTablKey]).map((item, index) => {
                return <tr key={index}>
                    {item}
                </tr>
            })}
        </thead>
        <tbody>
            {
                data.map((item) => {
                    return getTabTds(item).map((item, index) => {
                        return <tr key={index}>{item}</tr>
                    });
                })
            }
        </tbody>
    </>
}